export class Unit {
    idUnidade: number;
    nomeUnidade: string;
    cnpjUnidade: string;
}